import React, { useState } from "react";

import Lottie from "lottie-react";
// import { motion } from "framer-motion";
import Chef_cooking from "../Components/chef_cokking.json";


const Home = () => {
  return (
    <>
      <section class="text-gray-600 shadow-lg rounded-2xl  body-font mt-6 lg:mt-2">
        <div class="container mx-auto flex px-2 py-4 md:flex-row flex-col items-center">
          <div class="lg:flex-grow md:w-1/2 lg:pr-16 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
            <h1 class="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">
              Smcooks: Elevating Occasions with Freshness and Flavor
            </h1>
            <p class="mb-8 leading-relaxed">OPEN EVERY DAY AT 6:00AM-11:00PM</p>
            <div class="flex justify-center">
              <a href="/menu">
                <button class="inline-flex text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded text-lg">
                  View Menu
                </button>
              </a>
              <a href="/contact">
                <button class="ml-4 inline-flex text-gray-700 bg-gray-100 border-0 py-2 px-6 focus:outline-none hover:bg-white rounded text-lg">
                  Book Now
                </button>
              </a>
            </div>
          </div>

          <div class="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
            <Lottie
              class="object-cover object-center  lg:ml-[-200px] ml-[-50px] lg:w-[700px] lg:h-[630px] w-[430px] h-[370px] "
              animationData={Chef_cooking}
            />
          </div>
        </div>
      </section>

      {/* Menu  section*/}
      <section class="text-gray-600 body-font">
        <div class="container px-5 py-12 mx-auto">
          <div class="flex flex-wrap w-full ">
            <div class="lg:w-1/2 w-full ">
              <h1 class="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900">
                Our Featured Cuisines
              </h1>
              <div class="h-1 w-20 bg-indigo-500 rounded"></div>
            </div>
          </div>
        </div>
      </section>
      <section class="text-gray-600 body-font lg:mt-[-100px]">
        <div class="container px-5 py-24 mx-auto">
          <div class="lg:flex lg:flex-wrap grid grid-cols-2 -m-4 text-center lg:ml-[200px] ml-[0px]">
            <a href="/Vegetarian">
              <div class="p-4 md:w-1/4 lg:w-[200px]">
                <div class=" bg-gray-100 shadow-lg px-4 py-9 lg:px-4 lg:py-4  rounded-lg  ">
                  <div class="  ">
                    <img
                      src="\Images\Vegetarian\Masala Dosa.jpg"
                      alt="Gobi_Manchurian"
                      name="Gobi_Manchurian"
                      className=" w-60 h-20 rounded-md hover:scale-95 transition-all duration-500 cursor-pointer"
                    />
                  </div>
                  <p
                    className="text-black text-sm font-extrabold mt-5"
                    id="name"
                  >
                    VEGETARIAN
                  </p>
                </div>
              </div>
            </a>
            <a href="/Nonvegetarian">
              <div class="p-4 md:w-1/4 lg:w-[200px]">
                <div class="bg-gray-100 shadow-lg px-4 py-6 lg:px-4 lg:py-4  rounded-lg   ">
                  <div class=" ">
                    <img
                      src="\Images\Nonvegetarian\HYDERABADI DUM BIRYANI.jpg"
                      alt="Gobi_Manchurian"
                      name="Gobi_Manchurian"
                      className=" w-60 h-20 rounded-md hover:scale-95 transition-all duration-500 cursor-pointer"
                    />
                  </div>
                  <p
                    className="text-black text-sm font-extrabold mt-5"
                    id="name"
                  >
                    NON-VEGETARIAN
                  </p>
                </div>
              </div>
            </a>
            <a href="/Sweets">
              <div class="p-4 md:w-1/4 lg:w-[200px]">
                <div class="bg-gray-100 shadow-lg px-4 py-6 lg:px-4 lg:py-4  rounded-lg   ">
                  <div class=" ">
                    <img
                      src="\Images\Sweets\Rasmalai.webp"
                      alt="Gobi_Manchurian"
                      name="Gobi_Manchurian"
                      className=" w-60 h-20 rounded-md hover:scale-95 transition-all duration-500 cursor-pointer"
                    />
                  </div>
                  <p
                    className="text-black text-sm font-extrabold mt-5"
                    id="name"
                  >
                    SWEETS
                  </p>
                </div>
              </div>
            </a>
            <a href="/Beverage">
              <div class="p-4 md:w-1/4 lg:w-[200px]">
                <div class="bg-gray-100 shadow-lg px-4 py-6 lg:px-4 lg:py-4  rounded-lg   ">
                  <div class=" ">
                    <img
                      src="\Images\Beverage\Chai (Masala Tea).jpg"
                      alt="Gobi_Manchurian"
                      name="Gobi_Manchurian"
                      className=" w-60 h-20 rounded-md hover:scale-95 transition-all duration-500 cursor-pointer"
                    />
                  </div>
                  <p
                    className="text-black text-sm font-extrabold mt-5"
                    id="name"
                  >
                    BEVERAGE
                  </p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* About section  */}
      <section class="text-gray-600 body-font">
        <div class="container px-5 py-12 mx-auto">
          <div class="flex flex-wrap w-full ">
            <div class="lg:w-1/2 w-full ">
              <h1 class="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900">
                Know About us
              </h1>

              <div class="h-1 w-20 bg-indigo-500 rounded"></div>
            </div>
          </div>
        </div>
      </section>
      <section class="text-gray-600 body-font lg:mt-[-100px]">
        <div class="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
          <div class="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 mb-10 md:mb-0">
            <img
              class="object-cover object-center rounded"
              alt="hero"
              src="https://source.unsplash.com/720x600/?catering,cooking"
            />
          </div>
          <div class="lg:flex-grow md:w-1/2 lg:pl-24 md:pl-16 flex flex-col md:items-start md:text-left items-center text-center">
            <h1 class="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">
              {" "}
              Welcome to Smcooks:
              <br /> Where Culinary Excellence Begins
            </h1>
            <div>
              <p>
                Introducing Smcooks Catering, where excellence in culinary
                artistry meets the convenience of catering. Elevate your events
                with the same nationally acclaimed flavors that have made
                Smcooks the country's best in Indian cuisine.
              </p>
              <a href="/about">
                <p className="text-blue-700">Read more</p>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* service section  */}
      <section class="text-gray-600 body-font">
        <div class="container px-5 py-12 mx-auto">
          <div class="flex flex-wrap w-full ">
            <div class="lg:w-1/2 w-full ">
              <h1 class="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900">
                We Offer you for your special days
              </h1>
              <div class="h-1 w-20 bg-indigo-500 rounded"></div>
            </div>
          </div>
        </div>
      </section>
      <section class="text-gray-600 body-font lg:mt-[-100px]">
        <div class="container px-5 py-24 mx-auto">
          <div class="flex flex-wrap w-full mb-20">
            {/* <p class="lg:w-1/2 w-full leading-relaxed text-gray-500">Whatever cardigan tote bag tumblr hexagon brooklyn asymmetrical gentrify, subway tile poke farm-to-table. Franzen you probably haven't heard of them man bun deep jianbing selfies heirloom prism food truck ugh squid celiac humblebrag.</p> */}
          </div>
          <div class="flex flex-wrap -m-4">
            <div class="xl:w-1/4 md:w-1/2 p-4">
              <div class="bg-gray-100 shadow-lg p-6 rounded-lg">
                <img
                  class="h-40 rounded-lg w-full object-cover object-center mb-6 hover:scale-95 transition-all duration-500 cursor-pointer"
                  src="\Images\Services\Weddings.jpeg"
                  alt="content"
                />
                {/* <h3 class="tracking-widest text-indigo-500 text-xs font-medium title-font">SUBTITLE</h3> */}
                <h2 class="text-lg text-gray-900 font-medium title-font mb-4">
                  WEDDING
                </h2>
                <p class="leading-relaxed text-base">
                  Steps above the main dining room, this lavish space is
                  available for exclusive use each evening.
                </p>
              </div>
            </div>
            <div class="xl:w-1/4 md:w-1/2 p-4">
              <div class="bg-gray-100 shadow-lg p-6 rounded-lg">
                <img
                  class="h-40 rounded-lg w-full object-cover object-center mb-6 hover:scale-95 transition-all duration-500 cursor-pointer"
                  src="\Images\Services\BIRTHDAYS.jpg"
                  alt="content"
                />
                {/* <h3 class="tracking-widest text-indigo-500 text-xs font-medium title-font">
                  SUBTITLE
                </h3> */}
                <h2 class="text-lg text-gray-900 font-medium title-font mb-4">
                  BIRTHDAYS
                </h2>
                <p class="leading-relaxed text-base">
                  A festive birthday event space with opulent interior for any
                  more than thousand guests.
                </p>
                <br />
              </div>
            </div>
            <div class="xl:w-1/4 md:w-1/2 p-4">
              <div class="bg-gray-100 shadow-lg p-6 rounded-lg">
                <img
                  class="h-40 rounded-lg w-full object-cover object-center mb-6 hover:scale-95 transition-all duration-500 cursor-pointer"
                  src="\Images\Services\HOME CEREMONY.jpg"
                  alt="content"
                />
                {/* <h3 class="tracking-widest text-indigo-500 text-xs font-medium title-font">
                  SUBTITLE
                </h3> */}
                <h2 class="text-lg text-gray-900 font-medium title-font mb-4">
                  HOME CEREMONY
                </h2>
                <p class="leading-relaxed text-base">
                  Elevate your home ceremony with a tantalizing array of
                  flavors, personalized menus, and impeccable service.
                </p>
              </div>
            </div>
            <div class="xl:w-1/4 md:w-1/2 p-4">
              <div class="bg-gray-100 shadow-lg p-6 rounded-lg">
                <img
                  class="h-40 rounded-lg w-full object-cover object-center mb-6 hover:scale-95 transition-all duration-500 cursor-pointer"
                  src="\Images\Services\REUNION.jpg"
                  alt="content"
                />
                {/* <h3 class="tracking-widest text-indigo-500 text-xs font-medium title-font">
                  SUBTITLE
                </h3> */}
                <h2 class="text-lg text-gray-900 font-medium title-font mb-4">
                  REUNION
                </h2>
                <p class="leading-relaxed text-base">
                  A huge space for family or friends reunions
                </p>
                <br /> <br />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
